import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import BackIcon from '@mui/icons-material/ArrowBack';
import { Breadcrumbs, Button, Typography, Stack, Box } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { useWindowDimensions } from '../Utils';

// global theming ruins the back button, disable it here
const backTheme = createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                },
            },
        }
    }
});

export interface BreadCrumbProps {
    to: string,
    text: string
}

export interface PageProps {
    heading: React.ReactNode,
    errorComponent?: React.ReactNode,
    children?: React.ReactNode[],
    backButton?: boolean,
    breadcrumbs?: BreadCrumbProps[],
    sidePanel?: React.ReactNode
}

export const PageAlternate = ({ heading, errorComponent, children, backButton, breadcrumbs, sidePanel }: PageProps) => {
    const navigate = useNavigate();
    const [expandState, setExpandState] = React.useState(true); //true = expanded
    const { height, width } = useWindowDimensions();

    const maxHeight = height - 150 + 'px';
    const sidePanelwidth = width * 0.3;
    const mainWidth = width - sidePanelwidth + 'px';
    const spWidth = sidePanelwidth + 'px'

    const backButtonHandler = () => navigate(-1);
    const expandCollapseToggleHandler = () => setExpandState(!expandState);

    const visibleElement = { visibility: "visible" };
    const hiddenElement = { visibility: "hidden" };

    return <>
        <Stack direction="row" spacing={200}>
            <ThemeProvider theme={backTheme}>
                <Button startIcon={<BackIcon />} size="small" onClick={backButtonHandler} sx={backButton ? visibleElement : hiddenElement}>back</Button>
            </ThemeProvider>
            {breadcrumbs && <Breadcrumbs separator="|">
                {breadcrumbs.map((crumb, index) => (
                    <NavLink key={index} to={crumb.to}>{crumb.text}</NavLink>
                ))}
            </Breadcrumbs>}
        </Stack>

        <Stack direction="row" marginTop="10px" gap={10}>
            <Stack direction="row" minWidth={expandState ? spWidth : "max-content"} display={(sidePanel ? "flex" : "none")} marginTop="5" marginRight="5" minHeight={"calc(100vh - 180px)"}>
                <Box sx={{ flexGrow: 1, display: (expandState ? undefined : "none") }} style={{ maxHeight: maxHeight, overflow: 'auto' }}>
                    {sidePanel}
                </Box>
                <Button variant="outlined" sx={{ color: "text.primary", backgroundColor: "action.selected", maxWidth: "10px", minWidth: "10px", }} onClick={expandCollapseToggleHandler}>
                    {(expandState ? "<" : ">")}
                </Button>
            </Stack>
            <Stack sx={{ flexGrow: 1, width: mainWidth }} style={{ maxHeight: maxHeight, overflow: 'scroll' }}>
                {(typeof heading === 'string') ? <Typography variant="h4">{heading}</Typography> : heading}
                {errorComponent}
                {children}
            </Stack>
        </Stack>
    </>
}